import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../services/AuthContext';

const AdminSidebar = () => {
  const { user } = useAuth();
  const location = useLocation();

  const menuItems = [
    {
      path: '/admin/coaches',
      label: 'Manage Coaches',
      icon: 'psychology',
      color: 'text-tangerine',
      bgColor: 'bg-tangerine/10'
    },
    {
      path: '/admin/users',
      label: 'Manage Users',
      icon: 'group',
      color: 'text-blue-600 dark:text-blue-400',
      bgColor: 'bg-blue-500/10'
    },
    {
      path: '/admin/admins',
      label: 'Manage Admins',
      icon: 'admin_panel_settings',
      color: 'text-purple-600 dark:text-purple-400',
      bgColor: 'bg-purple-500/10'
    },
    {
      path: '/admin/finances',
      label: 'Finances',
      icon: 'payments',
      color: 'text-green-600 dark:text-green-400',
      bgColor: 'bg-green-500/10'
    }
  ];

  return (
    <aside className="w-full lg:w-80 flex flex-col shrink-0 space-y-6">
      <div className="bg-[var(--surface-white)] rounded-3xl shadow-xl shadow-black/5 border border-[var(--border-light)] overflow-hidden">
        <div className="p-6 space-y-8">
          {/* Admin Profile Hero */}
          <section className="space-y-4">
            <h3 className="text-xs font-bold text-[var(--text-secondary)]/60 uppercase tracking-widest flex items-center gap-2">
              <span className="material-symbols-outlined text-base">security</span>
              Admin Control
            </h3>
            <div className="p-8 rounded-[2rem] border border-[var(--border-light)] bg-gradient-to-b from-[var(--surface-white)] to-[var(--off-white)]/50 text-center relative group shadow-inner">
              <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-[var(--surface-white)] shadow-xl mb-4 relative ring-4 ring-[var(--off-white)]/50 bg-[var(--off-white)] flex items-center justify-center">
                {user?.avatarUrl ? (
                  <img 
                    alt="Admin Avatar" 
                    className="w-full h-full object-cover" 
                    src={`${process.env.REACT_APP_API_URL}${user.avatarUrl}`} 
                  />
                ) : (
                  <span className="material-symbols-outlined text-4xl text-purple-300">admin_panel_settings</span>
                )}
              </div>
              <h4 className="font-black text-[var(--text-primary)] text-xl tracking-tight mb-1">{user?.name || 'Administrator'}</h4>
              <p className="text-[10px] font-bold text-purple-600 uppercase tracking-[0.2em] leading-tight">System Admin</p>
            </div>
          </section>

          {/* Navigation Menu */}
          <section className="space-y-2">
            <h3 className="text-xs font-bold text-[var(--text-secondary)]/60 uppercase tracking-widest mb-4 flex items-center gap-2">
              <span className="material-symbols-outlined text-base">menu</span>
              Management
            </h3>
            <nav className="space-y-2">
              {menuItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center gap-3 px-4 py-3 rounded-2xl font-bold transition-all ${
                      isActive 
                        ? `${item.bgColor} ${item.color} shadow-sm border border-current/10` 
                        : 'text-[var(--text-secondary)] hover:bg-[var(--off-white)] hover:text-[var(--text-primary)]'
                    }`}
                  >
                    <span className="material-symbols-outlined">{item.icon}</span>
                    <span className="text-sm">{item.label}</span>
                    {isActive && (
                      <span className="ml-auto w-1.5 h-1.5 rounded-full bg-current"></span>
                    )}
                  </Link>
                );
              })}
            </nav>
          </section>

          {/* Quick Stats or Info */}
          <section className="pt-6 border-t border-[var(--border-light)]">
            <div className="bg-[var(--off-white)] rounded-2xl p-4 border border-[var(--border-light)]">
              <div className="flex items-center gap-2 mb-2">
                <span className="material-symbols-outlined text-sm text-[var(--text-secondary)]/60">info</span>
                <span className="text-[10px] font-bold text-[var(--text-secondary)]/60 uppercase tracking-wider">System Status</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-xs font-bold text-[var(--text-primary)]">All Systems Operational</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </aside>
  );
};

export default AdminSidebar;
